import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getTagsHelpStyles = (theme: Theme) =>
    css({
        borderTop: `1px solid ${theme.palette.gray.light}`,
    });

export const getSummaryStyles = (theme: Theme) =>
    css({
        display: 'flex',
        justifyContent: 'space-between',
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        cursor: 'pointer',

        '::marker': {
            display: 'none',
            content: '""',
        },

        '::-webkit-details-marker': {
            display: 'none',
        },
    });

export const getTitleStyles = () =>
    css({
        display: 'flex',
        alignItems: 'center',
    });

export const getIconColorStyles = (theme: Theme) =>
    css({
        color: theme.palette.primary.main,
    });

export const getInfoStyles = (theme: Theme) =>
    css({
        marginRight: theme.spacing(),
    });

export const getContentStyles = (theme: Theme) =>
    css({
        padding: `${theme.spacing()}px ${theme.spacing(5)}px ${theme.spacing(2)}px ${theme.spacing(5)}px`,
    });

export const getTagsDescriptionStyles = (theme: Theme) =>
    css({
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(),
        alignItems: 'baseline',
        margin: 0,
        marginBottom: theme.spacing(2),

        '& dt, & dd': {
            margin: 0,
        },
    });
